export default __webpack_public_path__ + "static/media/undraw_contact_us_-15-o2.1d273491.svg";